import { map, memoize } from 'lodash/fp';

export const mapWithIndexes = (map as $TSFixMe).convert({ cap: false });

export const asProp = (key: $TSFixMe) => (value: $TSFixMe) => ({
    [key]: value,
});

export const memoizeWithResolver = (memoize as $TSFixMe).convert({ fixed: false });
